/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Redshift RDS API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  ApiResponseActiveSessionRs,
  ApiResponseLockRs,
  ApiResponseParameterResponse,
  ApiResponseRedshiftParameterDetailRs,
  ApiResponseSessionDetailRs,
  ApiResponseSessionKillRs,
  ApiResponseSlowQueryRs,
  ApiResponseSqlByIntervalRs,
  ApiResponseSqlDetailHistoryRs,
  ApiResponseSqlInfoRs,
  ApiResponseSqlPlanRs,
  ApiResponseSqlRs,
  ApiResponseSqlTextRs,
  ApiResponseTableRs,
  ApiResponseUserLogRs,
  GetV7RedshiftActiveSessionByInstanceIdParams,
  GetV7RedshiftLockByInstanceIdParams,
  GetV7RedshiftParameterDetailByInstanceIdAndParameterNameParams,
  GetV7RedshiftSessionDetailByInstanceIdAndPidParams,
  GetV7RedshiftSlowQueryByInstanceIdParams,
  GetV7RedshiftSqlByInstanceIdParams,
  GetV7RedshiftSqlHistoryByInstanceIdParams,
  GetV7RedshiftSqlInfoByInstanceIdParams,
  GetV7RedshiftSqlPlanByInstanceIdParams,
  GetV7RedshiftSqlSqlByIntervalByInstanceIdParams,
  GetV7RedshiftSqlTextByInstanceIdParams,
  GetV7RedshiftUserLogByInstanceIdParams,
  SessionKillRq,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 액티브 세션은 now - 1분 이내 가장 최근 시간으로 조회합니다.
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 액티브 세션 탭
 */
export const getV7RedshiftActiveSessionByInstanceId = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7RedshiftActiveSessionByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<ApiResponseActiveSessionRs>(
    {
      url: `/api/v7/redshift/${instanceId}/active-session`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7RedshiftActiveSessionByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7RedshiftActiveSessionByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'redshift',
    instanceId,
    'active-session',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7RedshiftActiveSessionByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7RedshiftActiveSessionByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7RedshiftActiveSessionByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7RedshiftActiveSessionByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7RedshiftActiveSessionByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7RedshiftActiveSessionByInstanceId>>
  > = ({ signal }) =>
    getV7RedshiftActiveSessionByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7RedshiftActiveSessionByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7RedshiftActiveSessionByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7RedshiftActiveSessionByInstanceId>>
>;
export type GetV7RedshiftActiveSessionByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 액티브 세션 탭
 */

export function useGetV7RedshiftActiveSessionByInstanceId<
  TData = Awaited<ReturnType<typeof getV7RedshiftActiveSessionByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7RedshiftActiveSessionByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7RedshiftActiveSessionByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7RedshiftActiveSessionByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 액티브 세션 탭 > 선택된 세션 멀티 킬
 */
export const postV7RedshiftActiveSessionKillSessionsByInstanceId = (
  instanceId: MaybeRef<string>,
  sessionKillRq: MaybeRef<SessionKillRq[]>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  sessionKillRq = unref(sessionKillRq);

  return customAxiosInstance<ApiResponseSessionKillRs>(
    {
      url: `/api/v7/redshift/${instanceId}/active-session/kill-sessions`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: sessionKillRq,
      signal,
    },
    options,
  );
};

export const getPostV7RedshiftActiveSessionKillSessionsByInstanceIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7RedshiftActiveSessionKillSessionsByInstanceId>>,
    TError,
    { instanceId: string; data: BodyType<SessionKillRq[]> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7RedshiftActiveSessionKillSessionsByInstanceId>>,
  TError,
  { instanceId: string; data: BodyType<SessionKillRq[]> },
  TContext
> => {
  const mutationKey = ['postV7RedshiftActiveSessionKillSessionsByInstanceId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7RedshiftActiveSessionKillSessionsByInstanceId>>,
    { instanceId: string; data: BodyType<SessionKillRq[]> }
  > = (props) => {
    const { instanceId, data } = props ?? {};

    return postV7RedshiftActiveSessionKillSessionsByInstanceId(instanceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7RedshiftActiveSessionKillSessionsByInstanceIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7RedshiftActiveSessionKillSessionsByInstanceId>>
>;
export type PostV7RedshiftActiveSessionKillSessionsByInstanceIdMutationBody = BodyType<
  SessionKillRq[]
>;
export type PostV7RedshiftActiveSessionKillSessionsByInstanceIdMutationError = ErrorType<unknown>;

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 액티브 세션 탭 > 선택된 세션 멀티 킬
 */
export const usePostV7RedshiftActiveSessionKillSessionsByInstanceId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7RedshiftActiveSessionKillSessionsByInstanceId>>,
      TError,
      { instanceId: string; data: BodyType<SessionKillRq[]> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7RedshiftActiveSessionKillSessionsByInstanceId>>,
  TError,
  { instanceId: string; data: BodyType<SessionKillRq[]> },
  TContext
> => {
  const mutationOptions =
    getPostV7RedshiftActiveSessionKillSessionsByInstanceIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 액티브 세션은 now - 가장 최근 시간으로 조회합니다.
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 락 탭 - 스냅샷
 */
export const getV7RedshiftLockByInstanceId = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7RedshiftLockByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<ApiResponseLockRs>(
    { url: `/api/v7/redshift/${instanceId}/lock`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7RedshiftLockByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7RedshiftLockByInstanceIdParams>,
) => {
  return ['api', 'v7', 'redshift', instanceId, 'lock', ...(params ? [params] : [])] as const;
};

export const getGetV7RedshiftLockByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7RedshiftLockByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7RedshiftLockByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7RedshiftLockByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7RedshiftLockByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7RedshiftLockByInstanceId>>> = ({
    signal,
  }) => getV7RedshiftLockByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV7RedshiftLockByInstanceId>>, TError, TData>;
};

export type GetV7RedshiftLockByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7RedshiftLockByInstanceId>>
>;
export type GetV7RedshiftLockByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 락 탭 - 스냅샷
 */

export function useGetV7RedshiftLockByInstanceId<
  TData = Awaited<ReturnType<typeof getV7RedshiftLockByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7RedshiftLockByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7RedshiftLockByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7RedshiftLockByInstanceIdQueryOptions(instanceId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 파라미터 탭 - 스냅샷
 */
export const getV7RedshiftParameterByInstanceId = (
  instanceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);

  return customAxiosInstance<ApiResponseParameterResponse>(
    { url: `/api/v7/redshift/${instanceId}/parameter`, method: 'GET', signal },
    options,
  );
};

export const getGetV7RedshiftParameterByInstanceIdQueryKey = (instanceId?: MaybeRef<string>) => {
  return ['api', 'v7', 'redshift', instanceId, 'parameter'] as const;
};

export const getGetV7RedshiftParameterByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7RedshiftParameterByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7RedshiftParameterByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7RedshiftParameterByInstanceIdQueryKey(instanceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7RedshiftParameterByInstanceId>>> = ({
    signal,
  }) => getV7RedshiftParameterByInstanceId(instanceId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7RedshiftParameterByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7RedshiftParameterByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7RedshiftParameterByInstanceId>>
>;
export type GetV7RedshiftParameterByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 파라미터 탭 - 스냅샷
 */

export function useGetV7RedshiftParameterByInstanceId<
  TData = Awaited<ReturnType<typeof getV7RedshiftParameterByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7RedshiftParameterByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7RedshiftParameterByInstanceIdQueryOptions(instanceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Redshift - 파라미터 디테일 (Information과 History 분리)
 */
export const getV7RedshiftParameterDetailByInstanceIdAndParameterName = (
  instanceId: MaybeRef<string>,
  parameterName: MaybeRef<string>,
  params: MaybeRef<GetV7RedshiftParameterDetailByInstanceIdAndParameterNameParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  parameterName = unref(parameterName);
  params = unref(params);

  return customAxiosInstance<ApiResponseRedshiftParameterDetailRs>(
    {
      url: `/api/v7/redshift/${instanceId}/parameter/${parameterName}/detail`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7RedshiftParameterDetailByInstanceIdAndParameterNameQueryKey = (
  instanceId?: MaybeRef<string>,
  parameterName?: MaybeRef<string>,
  params?: MaybeRef<GetV7RedshiftParameterDetailByInstanceIdAndParameterNameParams>,
) => {
  return [
    'api',
    'v7',
    'redshift',
    instanceId,
    'parameter',
    parameterName,
    'detail',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7RedshiftParameterDetailByInstanceIdAndParameterNameQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7RedshiftParameterDetailByInstanceIdAndParameterName>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  parameterName: MaybeRef<string>,
  params: MaybeRef<GetV7RedshiftParameterDetailByInstanceIdAndParameterNameParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7RedshiftParameterDetailByInstanceIdAndParameterName>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7RedshiftParameterDetailByInstanceIdAndParameterNameQueryKey(
    instanceId,
    parameterName,
    params,
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7RedshiftParameterDetailByInstanceIdAndParameterName>>
  > = ({ signal }) =>
    getV7RedshiftParameterDetailByInstanceIdAndParameterName(
      instanceId,
      parameterName,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(instanceId) && unref(parameterName))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7RedshiftParameterDetailByInstanceIdAndParameterName>>,
    TError,
    TData
  >;
};

export type GetV7RedshiftParameterDetailByInstanceIdAndParameterNameQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7RedshiftParameterDetailByInstanceIdAndParameterName>>
>;
export type GetV7RedshiftParameterDetailByInstanceIdAndParameterNameQueryError = ErrorType<unknown>;

/**
 * @summary Redshift - 파라미터 디테일 (Information과 History 분리)
 */

export function useGetV7RedshiftParameterDetailByInstanceIdAndParameterName<
  TData = Awaited<ReturnType<typeof getV7RedshiftParameterDetailByInstanceIdAndParameterName>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  parameterName: MaybeRef<string>,
  params: MaybeRef<GetV7RedshiftParameterDetailByInstanceIdAndParameterNameParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7RedshiftParameterDetailByInstanceIdAndParameterName>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7RedshiftParameterDetailByInstanceIdAndParameterNameQueryOptions(
    instanceId,
    parameterName,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 세션 상세
 */
export const getV7RedshiftSessionDetailByInstanceIdAndPid = (
  instanceId: MaybeRef<string>,
  pid: MaybeRef<string>,
  params: MaybeRef<GetV7RedshiftSessionDetailByInstanceIdAndPidParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  pid = unref(pid);
  params = unref(params);

  return customAxiosInstance<ApiResponseSessionDetailRs>(
    {
      url: `/api/v7/redshift/${instanceId}/session-detail/${pid}`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7RedshiftSessionDetailByInstanceIdAndPidQueryKey = (
  instanceId?: MaybeRef<string>,
  pid?: MaybeRef<string>,
  params?: MaybeRef<GetV7RedshiftSessionDetailByInstanceIdAndPidParams>,
) => {
  return [
    'api',
    'v7',
    'redshift',
    instanceId,
    'session-detail',
    pid,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7RedshiftSessionDetailByInstanceIdAndPidQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7RedshiftSessionDetailByInstanceIdAndPid>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  pid: MaybeRef<string>,
  params: MaybeRef<GetV7RedshiftSessionDetailByInstanceIdAndPidParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7RedshiftSessionDetailByInstanceIdAndPid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7RedshiftSessionDetailByInstanceIdAndPidQueryKey(instanceId, pid, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7RedshiftSessionDetailByInstanceIdAndPid>>
  > = ({ signal }) =>
    getV7RedshiftSessionDetailByInstanceIdAndPid(instanceId, pid, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(instanceId) && unref(pid))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7RedshiftSessionDetailByInstanceIdAndPid>>,
    TError,
    TData
  >;
};

export type GetV7RedshiftSessionDetailByInstanceIdAndPidQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7RedshiftSessionDetailByInstanceIdAndPid>>
>;
export type GetV7RedshiftSessionDetailByInstanceIdAndPidQueryError = ErrorType<unknown>;

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 세션 상세
 */

export function useGetV7RedshiftSessionDetailByInstanceIdAndPid<
  TData = Awaited<ReturnType<typeof getV7RedshiftSessionDetailByInstanceIdAndPid>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  pid: MaybeRef<string>,
  params: MaybeRef<GetV7RedshiftSessionDetailByInstanceIdAndPidParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7RedshiftSessionDetailByInstanceIdAndPid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7RedshiftSessionDetailByInstanceIdAndPidQueryOptions(
    instanceId,
    pid,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * 슬로우 쿼리는 최근 5초(수집주기 5sec) 데이터 중 가장 최신 데이터 조회합니다.
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 슬로우 쿼리 탭 - 스냅샷
 */
export const getV7RedshiftSlowQueryByInstanceId = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7RedshiftSlowQueryByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<ApiResponseSlowQueryRs>(
    {
      url: `/api/v7/redshift/${instanceId}/slow-query`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7RedshiftSlowQueryByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7RedshiftSlowQueryByInstanceIdParams>,
) => {
  return ['api', 'v7', 'redshift', instanceId, 'slow-query', ...(params ? [params] : [])] as const;
};

export const getGetV7RedshiftSlowQueryByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7RedshiftSlowQueryByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7RedshiftSlowQueryByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7RedshiftSlowQueryByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7RedshiftSlowQueryByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7RedshiftSlowQueryByInstanceId>>> = ({
    signal,
  }) => getV7RedshiftSlowQueryByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7RedshiftSlowQueryByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7RedshiftSlowQueryByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7RedshiftSlowQueryByInstanceId>>
>;
export type GetV7RedshiftSlowQueryByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 슬로우 쿼리 탭 - 스냅샷
 */

export function useGetV7RedshiftSlowQueryByInstanceId<
  TData = Awaited<ReturnType<typeof getV7RedshiftSlowQueryByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7RedshiftSlowQueryByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7RedshiftSlowQueryByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7RedshiftSlowQueryByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > SQL 목록 탭 - 조회 기간 내 데이터
 */
export const getV7RedshiftSqlByInstanceId = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7RedshiftSqlByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<ApiResponseSqlRs>(
    { url: `/api/v7/redshift/${instanceId}/sql`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7RedshiftSqlByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7RedshiftSqlByInstanceIdParams>,
) => {
  return ['api', 'v7', 'redshift', instanceId, 'sql', ...(params ? [params] : [])] as const;
};

export const getGetV7RedshiftSqlByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7RedshiftSqlByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7RedshiftSqlByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7RedshiftSqlByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7RedshiftSqlByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7RedshiftSqlByInstanceId>>> = ({
    signal,
  }) => getV7RedshiftSqlByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV7RedshiftSqlByInstanceId>>, TError, TData>;
};

export type GetV7RedshiftSqlByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7RedshiftSqlByInstanceId>>
>;
export type GetV7RedshiftSqlByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > SQL 목록 탭 - 조회 기간 내 데이터
 */

export function useGetV7RedshiftSqlByInstanceId<
  TData = Awaited<ReturnType<typeof getV7RedshiftSqlByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7RedshiftSqlByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7RedshiftSqlByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7RedshiftSqlByInstanceIdQueryOptions(instanceId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Redshift SQL 의 플랜 조회 API
 */
export const getV7RedshiftSqlPlanByInstanceId = (
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7RedshiftSqlPlanByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<ApiResponseSqlPlanRs>(
    {
      url: `/api/v7/redshift/${instanceId}/sql-plan`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7RedshiftSqlPlanByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7RedshiftSqlPlanByInstanceIdParams>,
) => {
  return ['api', 'v7', 'redshift', instanceId, 'sql-plan', ...(params ? [params] : [])] as const;
};

export const getGetV7RedshiftSqlPlanByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7RedshiftSqlPlanByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7RedshiftSqlPlanByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7RedshiftSqlPlanByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7RedshiftSqlPlanByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7RedshiftSqlPlanByInstanceId>>> = ({
    signal,
  }) => getV7RedshiftSqlPlanByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV7RedshiftSqlPlanByInstanceId>>, TError, TData>;
};

export type GetV7RedshiftSqlPlanByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7RedshiftSqlPlanByInstanceId>>
>;
export type GetV7RedshiftSqlPlanByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary Redshift SQL 의 플랜 조회 API
 */

export function useGetV7RedshiftSqlPlanByInstanceId<
  TData = Awaited<ReturnType<typeof getV7RedshiftSqlPlanByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7RedshiftSqlPlanByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7RedshiftSqlPlanByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7RedshiftSqlPlanByInstanceIdQueryOptions(instanceId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Redshift SQL 의 fullText 를 조회하는 API
 */
export const getV7RedshiftSqlTextByInstanceId = (
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7RedshiftSqlTextByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<ApiResponseSqlTextRs>(
    {
      url: `/api/v7/redshift/${instanceId}/sql-text`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7RedshiftSqlTextByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7RedshiftSqlTextByInstanceIdParams>,
) => {
  return ['api', 'v7', 'redshift', instanceId, 'sql-text', ...(params ? [params] : [])] as const;
};

export const getGetV7RedshiftSqlTextByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7RedshiftSqlTextByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7RedshiftSqlTextByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7RedshiftSqlTextByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7RedshiftSqlTextByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7RedshiftSqlTextByInstanceId>>> = ({
    signal,
  }) => getV7RedshiftSqlTextByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV7RedshiftSqlTextByInstanceId>>, TError, TData>;
};

export type GetV7RedshiftSqlTextByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7RedshiftSqlTextByInstanceId>>
>;
export type GetV7RedshiftSqlTextByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary Redshift SQL 의 fullText 를 조회하는 API
 */

export function useGetV7RedshiftSqlTextByInstanceId<
  TData = Awaited<ReturnType<typeof getV7RedshiftSqlTextByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7RedshiftSqlTextByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7RedshiftSqlTextByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7RedshiftSqlTextByInstanceIdQueryOptions(instanceId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Redshift SQL 디테일 > 히스토리
 */
export const getV7RedshiftSqlHistoryByInstanceId = (
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7RedshiftSqlHistoryByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<ApiResponseSqlDetailHistoryRs>(
    {
      url: `/api/v7/redshift/${instanceId}/sql/history`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7RedshiftSqlHistoryByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7RedshiftSqlHistoryByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'redshift',
    instanceId,
    'sql',
    'history',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7RedshiftSqlHistoryByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7RedshiftSqlHistoryByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7RedshiftSqlHistoryByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7RedshiftSqlHistoryByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7RedshiftSqlHistoryByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7RedshiftSqlHistoryByInstanceId>>> = ({
    signal,
  }) => getV7RedshiftSqlHistoryByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7RedshiftSqlHistoryByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7RedshiftSqlHistoryByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7RedshiftSqlHistoryByInstanceId>>
>;
export type GetV7RedshiftSqlHistoryByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary Redshift SQL 디테일 > 히스토리
 */

export function useGetV7RedshiftSqlHistoryByInstanceId<
  TData = Awaited<ReturnType<typeof getV7RedshiftSqlHistoryByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7RedshiftSqlHistoryByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7RedshiftSqlHistoryByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7RedshiftSqlHistoryByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Redshift SQL 디테일 > 상단 정보
 */
export const getV7RedshiftSqlInfoByInstanceId = (
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7RedshiftSqlInfoByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<ApiResponseSqlInfoRs>(
    {
      url: `/api/v7/redshift/${instanceId}/sql/info`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7RedshiftSqlInfoByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7RedshiftSqlInfoByInstanceIdParams>,
) => {
  return ['api', 'v7', 'redshift', instanceId, 'sql', 'info', ...(params ? [params] : [])] as const;
};

export const getGetV7RedshiftSqlInfoByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7RedshiftSqlInfoByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7RedshiftSqlInfoByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7RedshiftSqlInfoByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7RedshiftSqlInfoByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7RedshiftSqlInfoByInstanceId>>> = ({
    signal,
  }) => getV7RedshiftSqlInfoByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV7RedshiftSqlInfoByInstanceId>>, TError, TData>;
};

export type GetV7RedshiftSqlInfoByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7RedshiftSqlInfoByInstanceId>>
>;
export type GetV7RedshiftSqlInfoByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary Redshift SQL 디테일 > 상단 정보
 */

export function useGetV7RedshiftSqlInfoByInstanceId<
  TData = Awaited<ReturnType<typeof getV7RedshiftSqlInfoByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7RedshiftSqlInfoByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7RedshiftSqlInfoByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7RedshiftSqlInfoByInstanceIdQueryOptions(instanceId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Redshift SQL 디테일 > 추이
 */
export const getV7RedshiftSqlSqlByIntervalByInstanceId = (
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7RedshiftSqlSqlByIntervalByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<ApiResponseSqlByIntervalRs>(
    {
      url: `/api/v7/redshift/${instanceId}/sql/sql-by-interval`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7RedshiftSqlSqlByIntervalByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7RedshiftSqlSqlByIntervalByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'redshift',
    instanceId,
    'sql',
    'sql-by-interval',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7RedshiftSqlSqlByIntervalByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7RedshiftSqlSqlByIntervalByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7RedshiftSqlSqlByIntervalByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7RedshiftSqlSqlByIntervalByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7RedshiftSqlSqlByIntervalByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7RedshiftSqlSqlByIntervalByInstanceId>>
  > = ({ signal }) =>
    getV7RedshiftSqlSqlByIntervalByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7RedshiftSqlSqlByIntervalByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7RedshiftSqlSqlByIntervalByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7RedshiftSqlSqlByIntervalByInstanceId>>
>;
export type GetV7RedshiftSqlSqlByIntervalByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary Redshift SQL 디테일 > 추이
 */

export function useGetV7RedshiftSqlSqlByIntervalByInstanceId<
  TData = Awaited<ReturnType<typeof getV7RedshiftSqlSqlByIntervalByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7RedshiftSqlSqlByIntervalByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7RedshiftSqlSqlByIntervalByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7RedshiftSqlSqlByIntervalByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 테이블 정보 탭 - 스냅샷
 */
export const getV7RedshiftTableByInstanceId = (
  instanceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);

  return customAxiosInstance<ApiResponseTableRs>(
    { url: `/api/v7/redshift/${instanceId}/table`, method: 'GET', signal },
    options,
  );
};

export const getGetV7RedshiftTableByInstanceIdQueryKey = (instanceId?: MaybeRef<string>) => {
  return ['api', 'v7', 'redshift', instanceId, 'table'] as const;
};

export const getGetV7RedshiftTableByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7RedshiftTableByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7RedshiftTableByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7RedshiftTableByInstanceIdQueryKey(instanceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7RedshiftTableByInstanceId>>> = ({
    signal,
  }) => getV7RedshiftTableByInstanceId(instanceId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV7RedshiftTableByInstanceId>>, TError, TData>;
};

export type GetV7RedshiftTableByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7RedshiftTableByInstanceId>>
>;
export type GetV7RedshiftTableByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 테이블 정보 탭 - 스냅샷
 */

export function useGetV7RedshiftTableByInstanceId<
  TData = Awaited<ReturnType<typeof getV7RedshiftTableByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7RedshiftTableByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7RedshiftTableByInstanceIdQueryOptions(instanceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 사용자 변경 이력 탭 - 조회 기간 내 로그 데이터
 */
export const getV7RedshiftUserLogByInstanceId = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7RedshiftUserLogByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<ApiResponseUserLogRs>(
    {
      url: `/api/v7/redshift/${instanceId}/user-log`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7RedshiftUserLogByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7RedshiftUserLogByInstanceIdParams>,
) => {
  return ['api', 'v7', 'redshift', instanceId, 'user-log', ...(params ? [params] : [])] as const;
};

export const getGetV7RedshiftUserLogByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7RedshiftUserLogByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7RedshiftUserLogByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7RedshiftUserLogByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7RedshiftUserLogByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7RedshiftUserLogByInstanceId>>> = ({
    signal,
  }) => getV7RedshiftUserLogByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV7RedshiftUserLogByInstanceId>>, TError, TData>;
};

export type GetV7RedshiftUserLogByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7RedshiftUserLogByInstanceId>>
>;
export type GetV7RedshiftUserLogByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 사용자 변경 이력 탭 - 조회 기간 내 로그 데이터
 */

export function useGetV7RedshiftUserLogByInstanceId<
  TData = Awaited<ReturnType<typeof getV7RedshiftUserLogByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7RedshiftUserLogByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7RedshiftUserLogByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7RedshiftUserLogByInstanceIdQueryOptions(instanceId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
